import {  useContext } from "react";
import { Disclosure } from "@headlessui/react";
import { Bars3Icon,  ArrowRightOnRectangleIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import AuthContext from "../AuthContext";
import ROUTES from "../constants/routes";


export default function Header({ onMenuClick }) {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSignOut = () => {
    authContext.signout();
    navigate(ROUTES.LOGIN);
  };

  return (
    <Disclosure as="nav" className="bg-primary shadow-sm sticky top-0 z-30">
      {() => (
        <>
          <div className="w-full px-2 sm:px-4 lg:px-6 lg:ml-0">
            <div className="flex h-14 sm:h-16 items-center justify-between">
              {/* Left section - Logo and mobile menu button */}
              <div className="flex items-center min-w-0 flex-1">
                {/* Mobile menu button */}
                <button
                  type="button"
                  onClick={onMenuClick}
                  className="inline-flex items-center justify-center rounded-md p-1.5 sm:p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white lg:hidden"
                  aria-label="Open sidebar"
                >
                  <Bars3Icon className="h-5 w-5 sm:h-6 sm:w-6" aria-hidden="true" />
                </button>

                {/* Logo */}
                <div className="flex items-center gap-1.5 sm:gap-2 ml-2 sm:ml-4 lg:ml-0 min-w-0">
                  <img
                    className="h-6 w-6 sm:h-8 sm:w-8 flex-shrink-0"
                    src={`${process.env.PUBLIC_URL || ""}/favicon.png`}
                    alt="Logo"
                  />
                  <span className="font-bold text-white italic text-sm sm:text-base hidden xs:inline truncate">
                    Uniform Junction
                  </span>
                  <span className="font-bold text-white italic text-sm sm:text-base hidden md:inline">
                    Admin
                  </span>
                </div>
              </div>

              {/* Right section - Notifications and profile */}
              <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
                {/* Profile dropdown */}
                <button
                  onClick={handleSignOut}
                  className="block w-full text-left px-3 sm:px-4 py-2 text-xs sm:text-sm font-bold text-white rounded-md"
                >
                  <ArrowRightOnRectangleIcon className="h-5 w-5 sm:h-6 sm:w-6" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </Disclosure>
  );
}
